import type { AreaCatalog } from '../area';
import type { agentKeys as en } from '../en/agentKeys';

export const agentKeys = {
  'agentKeys.machineRef': 'automation:{machine}',
  'agentKeys.minted': 'Schlüssel für {machine}. Er wird nur einmal gezeigt; kopiere ihn jetzt.',
  'agentKeys.mcpHint': 'Für den MCP-Server: {env} oder speichere ihn in {file}.',
  'agentKeys.env': 'COORD_API_KEY=<key>',
  'agentKeys.file': 'coord/.key',
  'agentKeys.copy': 'Kopieren',
  'agentKeys.done': 'OK',
  'agentKeys.revoked': 'widerrufen',
  'agentKeys.revoke': 'Widerrufen',
  'agentKeys.machine.label': 'Maschinen-ID',
  'agentKeys.machine.placeholder': 'Maschinen-ID',
  'agentKeys.label.label': 'Bezeichnung',
  'agentKeys.label.placeholder': 'Bezeichnung',
  'agentKeys.label.default': '{machine} (Agent)',
  'agentKeys.mint': 'Schlüssel erstellen',
  'agentKeys.may': 'Darf',
  'agentKeys.may.label': 'Was der Schlüssel darf',
  'agentKeys.may.read': 'Nur sehen',
  'agentKeys.may.write': 'Sehen und ändern',
  'agentKeys.may.manage': 'Sehen, ändern und teilen',
  'agentKeys.under': 'Unter',
  'agentKeys.under.remove': '{title} entfernen',
  'agentKeys.under.limit': 'Nur unter einer Aufgabe…',
  'agentKeys.under.add': 'Aufgabe hinzufügen…',
  'agentKeys.pick.title': 'Schlüssel beschränken',
  'agentKeys.pick.subtitle': 'Der Schlüssel erreicht diese Aufgabe und alles darunter.',
  'agentKeys.pick.search': 'Nach einer Aufgabe suchen, die der Schlüssel erreichen darf',
  'agentKeys.reach.label': 'Wo',
  'agentKeys.reach.everything': 'Überall',
  'agentKeys.reach.groups': 'Nur in diesen Gruppen',
  'agentKeys.reach.ownOnly': 'Nur deine eigenen Aufgaben',
  'agentKeys.reach.groupList': 'Deine Gruppen',
  'agentKeys.reach.groupInOrg': '{group} in {org}',
  'agentKeys.reach.own': 'Deine eigenen Aufgaben',
  'agentKeys.reach.ownHint':
    'Aufgaben, die du erstellt hast, für die du verantwortlich oder zuständig bist, oder die mit dir persönlich geteilt wurden.',
  'agentKeys.reach.left': {
    one: 'Sie nannte auch eine Gruppe, die du verlassen hast. Diese Gruppe fällt weg.',
    other: 'Sie nannte auch {count} Gruppen, die du verlassen hast. Diese Gruppen fallen weg.',
  },
  'agentKeys.reach.empty': 'Wähle mindestens eine Gruppe oder deine eigenen Aufgaben.',
  'agentKeys.reach.line.everything': 'Überall',
  'agentKeys.reach.line.groups': { one: 'In 1 Gruppe', other: 'In {count} Gruppen' },
  'agentKeys.reach.line.groupsOwn': {
    one: 'In 1 Gruppe und in deinen eigenen Aufgaben',
    other: 'In {count} Gruppen und in deinen eigenen Aufgaben',
  },
  'agentKeys.reach.line.own': 'Nur deine eigenen Aufgaben',
  'agentKeys.reach.line.under': { one: 'unter 1 Aufgabe', other: 'unter {count} Aufgaben' },
  'agentKeys.where.everything': 'alles, was du sehen kannst',
  'agentKeys.where.groups': 'nur in {groups}',
  'agentKeys.where.groupsOwn': 'nur in {groups} und in deinen eigenen Aufgaben',
  'agentKeys.where.own': 'nur in deinen eigenen Aufgaben',
  'agentKeys.where.leftGroup': 'eine Gruppe, die du verlassen hast',
  'agentKeys.where.under': 'unter {items}',
  'agentKeys.where.hiddenItem': 'eine Aufgabe, die du nicht sehen kannst',
} as const satisfies AreaCatalog<typeof en>;
